'use client';

import { EResumeType, ALLOW_SEARCHABLE } from '../../../../constants.js';

/**
 * Get last uploaded attach file from resumeInfo list
 * @param resumeInfo List of resume file
 * @returns single attach that is last uploaded
 */
function getLastUpload(resumeInfo) {
    if (!(resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.attributes)) {
        return null;
    }
    var attachResumes = resumeInfo.attributes.filter(function (item) { return item.isAttach === EResumeType.ATTACH; });
    if (attachResumes.length === 0) {
        return null;
    }
    // Case 1.4: Have both online and attach resume => get latest update
    var sortedAttachResumes = JSON.parse(JSON.stringify(attachResumes)).sort(function (a, b) {
        return new Date(b === null || b === void 0 ? void 0 : b.lastProcessedOn).getTime() - new Date(a === null || a === void 0 ? void 0 : a.lastProcessedOn).getTime();
    });
    // Latest update is first item in array
    if (sortedAttachResumes.length > 0) {
        return sortedAttachResumes[0];
    }
    return null;
}
/**
 * Get default resume (online or attach)
 * @param resumeInfo List of resume file
 * @returns single default selected resume (online or attach)
 */
function getDefaultResume(resumeInfo) {
    if (!(resumeInfo === null || resumeInfo === void 0 ? void 0 : resumeInfo.attributes)) {
        return null;
    }
    var lastAppliedResumes = resumeInfo.attributes.filter(function (item) { return item.isLastApplied; });
    var isHaveLastApplied = lastAppliedResumes.length > 0;
    // Case 2: Get last applied resume
    if (isHaveLastApplied) {
        // Last applied is online profile and must be allowSearchableDisplay
        if (!lastAppliedResumes[0].isAttach && lastAppliedResumes[0].allowSearchableDisplay !== ALLOW_SEARCHABLE) {
            return null;
        }
        return lastAppliedResumes[0];
    }
    // Case 1: Don't have applied resume
    // Case 1.1: Don't have any resume
    var isHaveResume = resumeInfo.attributes.length > 0;
    if (!isHaveResume) {
        return null;
    }
    // Online
    var onlineResumes = resumeInfo.attributes.filter(function (item) { return item.isAttach === EResumeType.ONLINE; });
    var isHaveOnline = onlineResumes.length > 0;
    // Attach
    var attachResumes = resumeInfo.attributes.filter(function (item) { return item.isAttach === EResumeType.ATTACH; });
    var isHaveAttach = attachResumes.length > 0;
    // Case 1.2: Have online resume but don't have attach resume
    // Online resume must allowSearchableDisplay (approved)
    if (isHaveOnline && !isHaveAttach && onlineResumes[0].allowSearchableDisplay === ALLOW_SEARCHABLE) {
        return onlineResumes[0];
    }
    // Case 1.3: Have attach resume but don't have online resume
    if (!isHaveOnline && isHaveAttach) {
        return attachResumes[0];
    }
    // Case 1.4: Have both online and attach resume => get latest update
    return getLastUpload(resumeInfo);
}

export { getDefaultResume, getLastUpload };
//# sourceMappingURL=getDefaultResume.js.map
